import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import SkillIcon from '../assets/imgs/profile-screen-images/skill-icon.svg'
import DeleteIcon from '../assets/imgs/profile-screen-images/delete-icon.svg'
import AddSkillsModal from './AddSkillsModal'
import RemovedSkillModal from './RemoveSkillModal'
import { saveOrUpdateDataById } from '../apis/generalApis'
import CreateServiceModal from './CreateServiceModal'
import UpdateServicIcon from '../assets/imgs/service_edit_icon.svg'
import { ScaleLoader } from 'react-spinners'
import { Avatar } from '@mui/material'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  borderRadius: '16px',
  textAlign: 'center',
}

const AddOrEditSkillsModal = ({
  handleAddOrEditSkillsModal,
  addOrEditSkillsModal = false,
  stylistSkills = [],
  setStylistServices,
  getStylistServices,
  handleUpdateService,
}) => {
  const [toggleAddSkillsModal, setToggleAddSkillsModak] = React.useState(false)
  const [createServiceModal, setCreateServiceModal] = React.useState(false)
  const user = JSON.parse(localStorage.getItem('user'))
  const [isNewService, setIsNewService] = React.useState(false)
  const [isLoading, setisLoading] = React.useState(false)
  const handleServiceDelete = async (service) => {
    let body = {
      service_id: service?.id,
      stylist_id: user?.id,
    }
    setisLoading(true)
    let result = await saveOrUpdateDataById('stylist-delete-service', body)
    setisLoading(false)
    if (result?.success === true) {
      handleSkillRemovedModal()
      const skills = stylistSkills.filter((skill) => skill.id !== service.id)
      stylistSkills = [...skills]
      setStylistServices(stylistSkills)
    }
  }

  const handleCreateServiceModal = () => {
    setCreateServiceModal((prev) => !prev)
  }

  const [skillRemovedModal, setSkillRemovedModal] = React.useState(false)
  const handleAddSkillsModal = () => {
    handleAddOrEditSkillsModal(false)
    setCreateServiceModal((prev) => !prev)
  }
  const handleSkillRemovedModal = () => {
    if (addOrEditSkillsModal) {
      handleAddOrEditSkillsModal(false)
    }
    setSkillRemovedModal(!skillRemovedModal)
  }
  return (
    <div>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 99999,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={addOrEditSkillsModal}
        onClose={() => handleAddOrEditSkillsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <h3 className="fs-24 mb-4 fw-bold">Add or Edit Services</h3>
          <div className="d-flex flex-column gap-3">
            {stylistSkills &&
              stylistSkills?.map((skill, index) => (
                <div className="skill-card p-3 text-white" key={skill.id}>
                  <div className="skill-card-header d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-1">
                      <Avatar
                        src={skill?.primary_image}
                        sx={{ height: 45, width: 45 }}
                      />
                      {/* <img
                        src={skill?.primary_image}
                        height={28}
                        width={28}
                        className="p-0"
                        style={{ borderRadius: '50%', objectFit: 'cover' }}
                      /> */}
                      <p className="fs-14 font-weight-bold d-inline-block">
                        {skill.name}
                      </p>
                    </div>
                    <div>
                      <img
                        src={UpdateServicIcon}
                        alt=""
                        height={'22px'}
                        className="pointer"
                        onClick={() => {
                          handleUpdateService(skill)
                          setIsNewService(false)
                        }}
                      />
                      <img
                        src={DeleteIcon}
                        alt=""
                        height={22}
                        className="pointer mx-1"
                        onClick={() => handleServiceDelete(skill)}
                      />
                    </div>
                  </div>
                  <div className="skill-card-body pt-2 text-left">
                    <p className="fs-18" style={{ wordBreak: 'break-all' }}>
                      {skill?.description}
                    </p>
                  </div>
                  <div className="skill-card-footer text-right">
                    <p className="fs-24 font-weight-bold">
                      ${skill.base_price}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <Button
            disableElevation
            variant="contained"
            id="btn-primary-no-shadow"
            className="pointer mt-5"
            fullWidth={true}
            onClick={() => {
              handleAddOrEditSkillsModal(false)
              setIsNewService(true)
              setCreateServiceModal(true)
            }}
          >
            Create New Service
          </Button>
        </Box>
      </Modal>
      <AddSkillsModal
        handleAddSkillsModal={handleAddSkillsModal}
        toggleAddSkillsModal={toggleAddSkillsModal}
        stylistSkills={stylistSkills}
      />
      <RemovedSkillModal
        handleRemovedSkillModal={handleSkillRemovedModal}
        modalOpen={skillRemovedModal}
      />
      <CreateServiceModal
        handleCreateServiceModal={handleCreateServiceModal}
        createServiceModal={createServiceModal}
        getStylistServices={getStylistServices}
        isNewService={isNewService}
        // handleAddOrEditSkillsModal={handleAddOrEditSkillsModal}
      />
    </div>
  )
}

export default AddOrEditSkillsModal
